import _ from "lodash";
import { useDispatch } from "react-redux";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import { Radio } from "@sportal/cdk";
import { RadioOptions } from "@sportal/cdk";
import { Button } from "../../../../../components";
import { addUrl } from "../../../../../store/lists/lists.actions";
import { ListType } from "@sportal/api/lists";
import { punyToUnicode } from "@sportal/lib";

import "./UrlOptions.scss";
import { useIntlTranslate } from "../../../../../hooks";

export const UrlOptions = ({ items, profileId }) => {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(_.last(items).node);

  return (
    <div className="url-options">
      <div className="url-options__info">
        <FormattedMessage id="whitelist_priority_warning" />
      </div>
      <RadioOptions
        selectedOption={selectedOption}
        name={"url-options"}
        onChange={(type) => setSelectedOption(type)}
        legend={<FormattedMessage id="select_domain_tip" />}
      >
        {items.map((item) => (
          <UrlOption
            type={item.type}
            url={item.node}
            id={item.type}
            key={item.type}
          />
        ))}
      </RadioOptions>
      <div className="url-options__actions">
        <Button
          size={"large"}
          color={"danger"}
          onClick={() =>
            dispatch(addUrl(ListType.Block, selectedOption, profileId))
          }
        >
          <FormattedMessage id={"block"} />
        </Button>
        <Button
          size={"large"}
          color={"success"}
          onClick={() =>
            dispatch(addUrl(ListType.Allow, selectedOption, profileId))
          }
        >
          <FormattedMessage id={"allow"} />
        </Button>
      </div>
    </div>
  );
};

const UrlOption = ({ url, type, id }) => {
  const translate = useIntlTranslate();

  return (
    <Radio
      className={"url-option"}
      value={url}
      key={type}
      ariaOptionLabel={`${translate(type)} ${url}`}
      id={id}
      label={
        <div className="url-option__label">
          <div className="url-option__label__type">
            <FormattedMessage id={type} />
          </div>
          <div className="url-option__label__url">{punyToUnicode(url)}</div>
        </div>
      }
    />
  );
};
